/**
 * Fishouflage WooCommerce Customizations
 *
 * Phone formatting, validation, text modifications, and UI customizations
 * for WooCommerce classic and blocks checkout.
 */

(function ($) {
    'use strict';

    /**
     * Phone Number Formatting & Validation
     */
    const PhoneHandler = {
        isTouchDevice: function () {
            if (typeof window === 'undefined' || typeof navigator === 'undefined') {
                return false;
            }
            if (window.matchMedia) {
                const mediaMatch = window.matchMedia('(pointer: coarse)').matches;
                if (mediaMatch) {
                    return true;
                }
            }
            return /Mobi|Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
        },

        getDigitsOnly: function (value) {
            return (value || '').replace(/[^\d]/g, '').slice(0, 10);
        },

        /**
         * Format phone number to US format: (XXX) XXX-XXXX
         */
        format: function (value) {
            if (!value) return value;
            const phoneNumber = value.replace(/[^\d]/g, '').slice(0, 10);
            const len = phoneNumber.length;
            if (len < 4) return phoneNumber;
            if (len < 7) {
                return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3);
            }
            return '(' + phoneNumber.slice(0, 3) + ') ' + phoneNumber.slice(3, 6) + '-' + phoneNumber.slice(6, 10);
        },

        /**
         * Validate US phone number
         * Returns true if valid or empty (required validation handled separately)
         */
        isValid: function (value) {
            if (!value) return true;
            const digits = value.replace(/[^\d]/g, '');
            if (digits.length !== 10) return false;
            // Area code cannot start with 0 or 1 (NANP rules)
            if (digits[0] === '0' || digits[0] === '1') return false;
            // Exchange code cannot start with 0 or 1 (NANP rules)
            if (digits[3] === '0' || digits[3] === '1') return false;
            return true;
        },

        /**
         * Show or hide validation error on input
         */
        showError: function (input, show) {
            const $input = $(input);
            const $container = $input.closest('.wc-block-components-text-input, .form-row');
            const errorId = $input.attr('id') + '-ff-error';
            const $existingError = $('#' + errorId);

            if (show) {
                if ($existingError.length === 0) {
                    const $errorMsg = $('<span>', {
                        id: errorId,
                        class: 'ff-phone-error',
                        css: {
                            color: '#cc0000',
                            fontSize: '12px',
                            display: 'block',
                            marginTop: '10px'
                        },
                        text: 'Please enter a valid phone number: (###) ###-####'
                    });
                    $container.append($errorMsg);
                }
                $input.css('border-color', '#cc0000');
            } else {
                $existingError.remove();
                $input.css('border-color', '');
            }
        },

        /**
         * Get all phone input selectors
         */
        getSelectors: function () {
            return [
                'input[type="tel"]',
                'input[name$="phone"]',
                'input[id$="phone"]',
                '#billing_phone',
                '#shipping_phone',
                '#billing-phone',
                '#shipping-phone'
            ].join(', ');
        },

        /**
         * Apply phone mask and validation to all phone inputs
         */
        applyToInputs: function () {
            const self = this;
            $(this.getSelectors()).each(function () {
                const input = this;
                if (input.dataset.ffPhoneBound) return;
                input.dataset.ffPhoneBound = 'true';

                const $input = $(input);

                // Set attributes
                $input.attr({
                    'maxlength': 14,
                    'inputmode': 'numeric',
                    'autocomplete': 'tel-national'
                });

                // Format on input
                $input.on('input.ffPhone', function () {
                    const digitsOnly = self.getDigitsOnly($input.val());
                    const isTouch = self.isTouchDevice();

                    if (isTouch) {
                        if ($input.val() !== digitsOnly) {
                            $input.val(digitsOnly);
                        }
                    } else {
                        const formatted = self.format(digitsOnly);
                        if ($input.val() !== formatted) {
                            $input.val(formatted);
                        }
                    }
                    $input.data('ffPhoneDigits', digitsOnly);
                });

                // Validate on blur
                $input.on('blur.ffPhone', function () {
                    const val = self.format($input.data('ffPhoneDigits') || self.getDigitsOnly($input.val()));
                    $input.val(val);
                    $input.data('ffPhoneDigits', self.getDigitsOnly(val));

                    if (val && !self.isValid(val)) {
                        self.showError(input, true);
                    } else {
                        self.showError(input, false);
                    }
                });

                // Clear error on focus
                $input.on('focus.ffPhone', function () {
                    self.showError(input, false);
                });

                // Initial format if value exists
                if ($input.val()) {
                    const digitsOnly = self.getDigitsOnly($input.val());
                    const isTouch = self.isTouchDevice();
                    $input.val(isTouch ? digitsOnly : self.format(digitsOnly));
                    $input.data('ffPhoneDigits', digitsOnly);
                }
            });
        },

        /**
         * Initialize phone handling with MutationObserver for React/Blocks
         */
        init: function () {
            const self = this;

            // Apply immediately
            self.applyToInputs();

            // Watch for DOM changes (for Blocks/React)
            const observer = new MutationObserver(function () {
                self.applyToInputs();
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    };

    /**
     * Cart/Checkout Block Text Modifications
     */
    const BlockTextHandler = {
        /**
         * Text replacements to apply
         */
        replacements: {
            'Estimated total': 'Total',
            'Add coupons': 'Add a Promo Code',
            'Add a coupon': 'Add a Promo Code',
            'Coupon code': 'Promo Code',
            'Apply coupon': 'Apply Promo Code'
        },

        /**
         * Apply all text replacements
         */
        applyReplacements: function () {
            const self = this;

            // Target common WooCommerce block text elements
            $('.wc-block-components-totals-item__label, .wc-block-components-panel__button-text, .wc-block-components-text-input label, .wc-block-components-button__text').each(function () {
                const $el = $(this);
                const text = $el.text().trim();

                if (self.replacements[text]) {
                    $el.text(self.replacements[text]);
                }
            });

            // Also check for "Estimated total" specifically in the footer item
            $('.wc-block-components-totals-footer-item .wc-block-components-totals-item__label').each(function () {
                if ($(this).text().trim() === 'Estimated total') {
                    $(this).text('Total');
                }
            });
        },

        /**
         * Initialize with MutationObserver for React/Blocks
         */
        init: function () {
            const self = this;

            // Apply immediately
            self.applyReplacements();

            // Watch for DOM changes
            const observer = new MutationObserver(function () {
                self.applyReplacements();
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    };

    /**
     * Mailchimp Newsletter Checkbox Handler
     */
    const MailchimpHandler = {
        /**
         * Hide Mailchimp newsletter checkbox
         */
        hideCheckbox: function () {
            $('#subscribe-to-newsletter').closest('.wc-block-components-checkbox').hide();
            $('.mailchimp-newsletter').hide();
        },

        /**
         * Initialize with MutationObserver for React/Blocks
         */
        init: function () {
            const self = this;

            // Apply immediately
            self.hideCheckbox();

            // Watch for DOM changes
            const observer = new MutationObserver(function () {
                self.hideCheckbox();
            });
            observer.observe(document.body, { childList: true, subtree: true });
        }
    };

    /**
     * Initialize all handlers when DOM is ready
     */
    $(function () {
        // Check page type via body classes
        const isCheckout = $('body').hasClass('woocommerce-checkout');
        const isCart = $('body').hasClass('woocommerce-cart');
        const isAccount = $('body').hasClass('woocommerce-account');

        // Phone formatting on checkout, cart, and account pages
        if (isCheckout || isCart || isAccount) {
            PhoneHandler.init();
        }

        // Block text modifications (coupon -> promo code, estimated total -> total)
        if (isCart || isCheckout) {
            BlockTextHandler.init();
        }

        // Hide Mailchimp checkbox on checkout
        if (isCheckout) {
            MailchimpHandler.init();
        }
    });

})(jQuery);
